module.exports = __webpack_public_path__ + "static/media/javascript the definitive guide.b179f277.pdf";